import { useContext } from 'react';

import { ProjectTypeContext } from 'App';
import { ProjectType } from 'const';

export const useProjectType = (): ProjectType => {
  return useContext(ProjectTypeContext);
};
